import { PermitTypeClient } from '@src/permitTypesManager/services/PermitTypeClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const usePermitTypeDeactivation = () => {
  const queryClient = useQueryClient();
  const { mutate: deactivateType, isPending: isDeactivating } = useMutation({
    mutationFn: (permitTypeId: string) =>
      PermitTypeClient.deactivateType(permitTypeId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['permitTypes.list'] });
    },
  });

  const { mutate: reactivateType, isPending: isReactivating } = useMutation({
    mutationFn: (permitTypeId: string) =>
      PermitTypeClient.reactivateType(permitTypeId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['permitTypes.list'] });
    },
  });

  return {
    deactivateType,
    reactivateType,
    isLoading: isDeactivating || isReactivating,
  };
};
